import { v1 as uuidv1 } from 'uuid';

export const START_LOADING = `employees: START_LOADING→${uuidv1()}`;
export const STOP_LOADING = `employees: STOP_LOADING→${uuidv1()}`;
export const SET_LAST_CLOCK_IN = 'employees: SET_LAST_CLOCK_IN';
export const RESET_LAST_CLOCK_IN = 'employees: RESET_LAST_CLOCK_IN';
